angular.module('iqxCore')
.controller('ActionDialogLegacyContactEventsModalCtrl', function ($scope, $location, FormSvc, $sce) {
	$scope.ContactEventDetails = undefined
	$scope.showAll=false

	switch($scope.contactEvents.obj.type.toLowerCase()) {
		case 'person':
			$scope.typeID = "pPersonID"
		break

		case 'staff':
			$scope.typeID = "pStaffID"
		break

		case 'contact':
			$scope.typeID = "pEmploymentID"
		break

		case 'vacancy':
			$scope.typeID = "pVacancyID"
		break

		case 'company':
			$scope.typeID = "pCompanyID"
		break

		default:
			$scope.typeID="NONE"
		break
	}

	$scope.fetchContactEvents=function(){
		FormSvc.setOptions($scope,{
			fetchAPI:'callresult/NetOwnerContactEvents?'+$scope.typeID+'='+$scope.contactEvents.obj.linkID+($scope.showAll ? '&pAllEvents=1' : '' ),
			multiRow:true,
			sliceSize:6
		})
		switch($scope.showAll){
			case true:
				$scope.showAll=false
			break

			case false:
				$scope.showAll=true
			break
		}
		$scope.fetch()
	}

	$scope.goBack=function(){
		$scope.ContactEventDetails = undefined
	}

	$scope.humanifyString=function(string){
		return string
		.replace(/([A-Z])/g, ' $1')
		.replace(/^./, function(str){ return str.toUpperCase(); })
	}

	$scope.contactEventMoreInfo=function(ContactEvent){
		delete ContactEvent['$$hashKey']
		delete ContactEvent['ContactEventID']
		delete ContactEvent['Priority']
		$scope.ContactEventDetails = ContactEvent
		angular.forEach(ContactEvent, function(event, key){ // Trust our output
			$scope.ContactEventDetails[key] = $sce.trustAsHtml(ContactEvent[key])
		})
	}

	$scope.fetchContactEvents()
})